import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n\n        /* stylelint-disable-next-line no-duplicate-selectors */\n        &::placeholder {\n          ", ";\n        }\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  appearance: none;\n  background-color: transparent;\n  border: 0;\n  bottom: 0;\n  cursor: ", ";\n  font-size: inherit;\n  height: 100%;\n  left: 0;\n  padding: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n\n  &::placeholder {\n    color: transparent;\n  }\n\n  &::-ms-clear {\n    display: none;\n  }\n\n  &:focus {\n    cursor: text;\n    outline: none;\n\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React from 'react';
import styled, { css } from 'styled-components';
import { placeholder } from '@scp/ui-shared/theme/typography-styles';
import { withoutProps } from '@scp/ui-shared/core/hoc';
import { color } from '@scp/ui-shared/theme/variables';
var TEXT = {
  PLACEHOLDER: function PLACEHOLDER(fieldName) {
    return "Type to search ".concat(fieldName, "...");
  }
};
var PROPS_TO_OMIT = ['showPlaceholderOnFocus', 'autoCorrect', 'selectProps', 'theme', 'getStyles', 'isHidden', 'hasSelectedValues'];
var Input = styled(withoutProps('input', PROPS_TO_OMIT))(_templateObject(), function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.showPlaceholderOnFocus && css(_templateObject2(), color.palette.white, placeholder);
});
export function FieldInput(_a) {
  var _a$menuIsOpen = _a.menuIsOpen,
      menuIsOpen = _a$menuIsOpen === void 0 ? false : _a$menuIsOpen,
      _a$value = _a.value,
      value = _a$value === void 0 ? '' : _a$value,
      _a$isDisabled = _a.isDisabled,
      isDisabled = _a$isDisabled === void 0 ? false : _a$isDisabled,
      name = _a.name,
      _a$innerRef = _a.innerRef,
      innerRef = _a$innerRef === void 0 ? function () {
    return null;
  } : _a$innerRef,
      searchPlaceholder = _a.searchPlaceholder,
      props = __rest(_a, ["menuIsOpen", "value", "isDisabled", "name", "innerRef", "searchPlaceholder"]);

  return React.createElement(Input, Object.assign({}, props, {
    ref: innerRef,
    value: value,
    placeholder: !!searchPlaceholder ? searchPlaceholder : TEXT.PLACEHOLDER(name.toLowerCase()),
    disabled: isDisabled,
    showPlaceholderOnFocus: menuIsOpen || !!value
  }));
}